
export const API_AI_ACTIONS = '/api/ai/v1/copilot/actions';

export enum AI_ACTION_TYPE {
    ACTION_TYPE_UNKNOWN = 0,

    ACTION_TYPE_RECOMMEND_INSTRUCTION = 10001, // 获取推荐指令
    ACTION_TYPE_GENERATE_IMAGE = 10002, // 生成图片
    ACTION_TYPE_SEARCH_IMAGE = 10003, // 智能搜图
    ACTION_TYPE_GENERATE_DOCUMENT = 10004, // 生成文档内容
    ACTION_TYPE_MODIFY_CONTENT = 10005, // 修改文档内容
    ACTION_TYPE_SUMMARY_CONTENT = 10006, // 总结选中内容
    ACTION_TYPE_TRANSLATE = 10007, // 翻译指定内容
    ACTION_TYPE_UPLOAD_IMAGE = 10008, // 通过url上传图片
    ACTION_TYPE_IMAGE_POSITION = 10009, // markdown 生成关键词
    ACTION_TYPE_GENERATE_CHART = 10022, // markdown 生成关键词
}

export const AI_ACTION_NAME_MAP: Record<AI_ACTION_TYPE, string> = {
    [AI_ACTION_TYPE.ACTION_TYPE_UNKNOWN]: '',
    [AI_ACTION_TYPE.ACTION_TYPE_RECOMMEND_INSTRUCTION]: 'recommend_instruction',
    [AI_ACTION_TYPE.ACTION_TYPE_GENERATE_IMAGE]: 'generate_image',
    [AI_ACTION_TYPE.ACTION_TYPE_SEARCH_IMAGE]: 'search_image',
    [AI_ACTION_TYPE.ACTION_TYPE_GENERATE_DOCUMENT]: 'generate_document',
    [AI_ACTION_TYPE.ACTION_TYPE_MODIFY_CONTENT]: 'modify_content',
    [AI_ACTION_TYPE.ACTION_TYPE_SUMMARY_CONTENT]: 'summary_content',
    [AI_ACTION_TYPE.ACTION_TYPE_TRANSLATE]: 'translate',
    [AI_ACTION_TYPE.ACTION_TYPE_UPLOAD_IMAGE]: 'upload_image',
    [AI_ACTION_TYPE.ACTION_TYPE_IMAGE_POSITION]: 'image_position',
    [AI_ACTION_TYPE.ACTION_TYPE_GENERATE_CHART]: 'gen_slide_chart',
};
